import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-blush">
      {/* Inklusions-Sektion */}
      <div className="border-t border-rose/15">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-7">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8">
            {/* Inklusion */}
            <div className="flex items-center gap-3">
              {/* Dezente Regenbogen-Streifen als kleines Icon */}
              <div className="flex-shrink-0 w-6 h-6 rounded-full overflow-hidden flex flex-col">
                <div className="flex-1" style={{ background: '#e8534a' }} />
                <div className="flex-1" style={{ background: '#f5a623' }} />
                <div className="flex-1" style={{ background: '#f8e71c' }} />
                <div className="flex-1" style={{ background: '#7ed321' }} />
                <div className="flex-1" style={{ background: '#4a90e2' }} />
                <div className="flex-1" style={{ background: '#9b59b6' }} />
              </div>
              <p className="font-sans text-xs text-charcoal/65 leading-relaxed">
                Bei Flow &amp; Glow ist jede Person willkommen — unabhängig von Geschlecht, Identität, Herkunft oder Alter. Dein Lächeln zählt.
              </p>
            </div>

            {/* Divider */}
            <div className="hidden sm:block w-px h-8 bg-rose/20 flex-shrink-0" />

            {/* Female Founded */}
            <div className="flex items-center gap-2.5 flex-shrink-0">
              <div className="w-7 h-7 flex items-center justify-center bg-rose/15 rounded-full flex-shrink-0">
                <i className="ri-women-line text-rose text-sm" />
              </div>
              <p className="font-sans text-xs font-medium text-charcoal/70 whitespace-nowrap">
                Inhabergeführt — von einer Frau, für alle
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-8 pt-10 pb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 pb-10 border-b border-rose/20">

          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="block mb-3">
              <span className="font-serif text-2xl font-medium text-charcoal">Flow &amp; Glow</span>
            </Link>
            <p className="font-sans text-sm text-charcoal/70 leading-relaxed mb-5">
              Kosmetische Zahnaufhellung in Köln — schmerzfrei, professionell, strahlend.
            </p>
            <a
              href="https://www.instagram.com/flowundglow"
              target="_blank"
              rel="nofollow noreferrer"
              className="inline-flex items-center gap-2 text-charcoal/70 hover:text-rose transition-colors duration-200 cursor-pointer"
            >
              <span className="w-8 h-8 flex items-center justify-center">
                <i className="ri-instagram-line text-xl" />
              </span>
              <span className="font-sans text-sm">@flowundglow</span>
            </a>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-sans text-xs font-semibold uppercase tracking-widest text-charcoal mb-4">
              Navigation
            </h4>
            <ul className="flex flex-col gap-3">
              {[
                { label: 'Startseite', to: '/' },
                { label: 'Leistungen', to: '/leistungen' },
                { label: 'Über mich', to: '/ueber-mich' },
                { label: 'FAQ', to: '/faq' },
                { label: 'Standort Köln', to: '/standort' },
              ].map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="font-sans text-sm text-charcoal/70 hover:text-rose transition-colors duration-200 cursor-pointer"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Kontakt */}
          <div>
            <h4 className="font-sans text-xs font-semibold uppercase tracking-widest text-charcoal mb-4">
              Kontakt
            </h4>
            <ul className="flex flex-col gap-3">
              <li className="flex items-start gap-2">
                <span className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-rose text-base" />
                </span>
                <span className="font-sans text-sm text-charcoal/70 leading-relaxed">
                  Standort in Köln —<br />Adresse folgt in Kürze
                </span>
              </li>
              <li className="flex items-center gap-2">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-rose text-base" />
                </span>
                <a
                  href="mailto:hallo@flowundglow.de"
                  className="font-sans text-sm text-charcoal/70 hover:text-rose transition-colors duration-200 cursor-pointer"
                >
                  hallo@flowundglow.de
                </a>
              </li>
              <li className="flex items-center gap-2">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-whatsapp-line text-rose text-base" />
                </span>
                <a
                  href="https://wa.me/4922100000"
                  rel="nofollow noreferrer"
                  className="font-sans text-sm text-charcoal/70 hover:text-rose transition-colors duration-200 cursor-pointer"
                >
                  WhatsApp schreiben
                </a>
              </li>
            </ul>
          </div>

        </div>

        {/* Bottom bar */}
        <div className="flex flex-col items-center gap-3 pt-6">
          <p className="font-sans text-xs text-charcoal/50 text-center">
            Flow &amp; Glow ist ein kosmetisches Studio und keine zahnärztliche Praxis. Alle Anwendungen sind rein kosmetischer Natur.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 w-full">
            <p className="font-sans text-xs text-charcoal/50">
              © 2026 Flow &amp; Glow · Köln · Alle Rechte vorbehalten
            </p>
            <div className="flex items-center gap-5">
              <Link
                to="/impressum"
                className="font-sans text-xs text-charcoal/50 hover:text-rose transition-colors duration-200 cursor-pointer"
              >
                Impressum
              </Link>
              <Link
                to="/datenschutz"
                className="font-sans text-xs text-charcoal/50 hover:text-rose transition-colors duration-200 cursor-pointer"
              >
                Datenschutz
              </Link>
              <a
                href="https://www.instagram.com/flowundglow"
                target="_blank"
                rel="nofollow noreferrer"
                aria-label="Flow & Glow auf Instagram"
                className="w-7 h-7 flex items-center justify-center text-charcoal/50 hover:text-rose transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-instagram-line text-base" />
              </a>
              <a
                href="https://wa.me/4922100000"
                rel="nofollow noreferrer"
                aria-label="WhatsApp"
                className="w-7 h-7 flex items-center justify-center text-charcoal/50 hover:text-rose transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-whatsapp-line text-base" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
